import { render } from "./PartnerUsersHeader.vue?vue&type=template&id=812960d4"
import script from "./PartnerUsersHeader.vue?vue&type=script&lang=js"
export * from "./PartnerUsersHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__